import { useContext } from "react"
import { EnumValueContext } from "./enum-value-context";

export function useEnumValue() {
  return useContext(EnumValueContext);
}
